import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getProfileToDisplay } from 'app/reducer/profileRedux';
import { PROFILE_EDIT_TYPE } from 'app/constants/profile';

import { Modal } from 'app/seedly-component-library';
import EditProfileForm from 'app/components/profile/EditProfileForm';
import EditProfilePage from 'app/components/profile/EditProfilePage';
import Profile from './Profile';

const ProfileContent = () => {
  const profile = useSelector(getProfileToDisplay);

  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const handleEditProfileOptions = isModalParam => {
    setIsEditingProfile(currentIsEditingProfile => !currentIsEditingProfile);
    setIsModal(isModalParam);
  };

  const shoulRenderDesktopEdit = isEditingProfile && !isModal;
  const shoulRenderMobileEdit = isEditingProfile && isModal;

  return (
    <div className="flex flex-col pt-2 w-full lg:w-[1024px] lg:pt-4 lg:flex-row">
      {shoulRenderDesktopEdit ? (
        <EditProfilePage
          onViewProfileClick={() => setIsEditingProfile(false)}
        />
      ) : (
        !isEmpty(profile) && (
          <Profile handleEditProfileOptions={handleEditProfileOptions} />
        )
      )}
      {shoulRenderMobileEdit && (
        <Modal
          ariaHideApp={false}
          isOpen={isEditingProfile}
          onRequestClose={handleEditProfileOptions}
          headerTitle="Edit Profile"
          withCloseButton
          label="edit-profile"
        >
          <EditProfileForm editType={PROFILE_EDIT_TYPE.MOBILE} />
        </Modal>
      )}
    </div>
  );
};

export default ProfileContent;
